import { JSX } from 'react'

import { IconProps } from '../../icon'

const ExternalLink: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M32.2051 8H15.7949C11.4954 8 8 11.4954 8 15.7949C8 16.4677 8.55795 17.0256 9.23077 17.0256C9.90359 17.0256 10.4615 16.4677 10.4615 15.7949C10.4615 12.8574 12.8574 10.4615 15.7949 10.4615H32.2051C35.1426 10.4615 37.5385 12.8574 37.5385 15.7949V32.2051C37.5385 35.1426 35.1426 37.5385 32.2051 37.5385H15.7949C12.8574 37.5385 10.4615 35.1426 10.4615 32.2051C10.4615 31.5323 9.90359 30.9744 9.23077 30.9744C8.55795 30.9744 8 31.5323 8 32.2051C8 36.5046 11.4954 40 15.7949 40H32.2051C36.5046 40 40 36.5046 40 32.2051V15.7949C40 11.4954 36.5046 8 32.2051 8Z'
      fill='black'
    />
    <path
      d='M8 24C8 24.6728 8.55795 25.2308 9.23077 25.2308H27.5938L23.1303 29.6944C22.6544 30.1703 22.6544 30.9579 23.1303 31.4338C23.3764 31.68 23.6882 31.7949 24 31.7949C24.3118 31.7949 24.6236 31.68 24.8697 31.4338L31.4338 24.8697C31.9097 24.3938 31.9097 23.6062 31.4338 23.1303L24.8697 16.5662C24.3938 16.0903 23.6062 16.0903 23.1303 16.5662C22.6544 17.042 22.6544 17.8297 23.1303 18.3056L27.5938 22.7692H9.23077C8.55795 22.7692 8 23.3272 8 24Z'
      fill='black'
    />
  </svg>
)

export default ExternalLink
